import { CommonUIModule } from '../webpack';
/** @component React Components */
export const Toggle = Object.values(CommonUIModule).find((mod) => mod?.render?.toString()?.includes('.ToggleOff)'));
